// extracted by mini-css-extract-plugin
export var header = "Header-module--header--SgSZ4";
export var headerTransparent = "Header-module--header--transparent--L1LTN";